export const ASSISTANT_TARGET_KEY = {
  dashboardNeedsAttention: 'dashboard.needs_attention',
  dashboardCalendar: 'dashboard.calendar',
  dashboardAppointmentRow: 'dashboard.appointment_row',
  devicesAddButton: 'settings.devices.add_button',
  deviceCard: 'settings.devices.card',
  deviceEditButton: 'settings.devices.edit_button',
  integrationsCalendarSync: 'settings.integrations.calendar_sync',
  integrationsEmailProvider: 'settings.integrations.email_provider',
  integrationsSmsProvider: 'settings.integrations.sms_provider',
  patientHeader: 'patient.header',
  patientRecordTabs: 'patient.record_tabs',
  clientInvitationStatus: 'client.invitation_status',
  teamInviteButton: 'team.invite_button',
  organizationRetentionField: 'organization.retention_field',
  servicesAddButton: 'settings.services.add_button',
} as const;

export type AssistantTargetKey = (typeof ASSISTANT_TARGET_KEY)[keyof typeof ASSISTANT_TARGET_KEY];

export const ASSISTANT_TARGET_KEYS: AssistantTargetKey[] = Object.values(ASSISTANT_TARGET_KEY);
